const OPTIONS = [
  { id: "satellite", label: "Satellite" },
  { id: "dark", label: "Dark" },
  { id: "streets", label: "Streets" },
];

export const BasemapToggle = ({ basemap, setBasemap }) => (
  <div className="absolute top-20 right-4 z-[500] flex gap-1 p-1 bg-black/70 backdrop-blur-xl border border-white/15 rounded-full shadow-2xl" data-testid="basemap-toggle">
    {OPTIONS.map((b) => (
      <button
        key={b.id}
        data-testid={`basemap-${b.id}`}
        onClick={() => setBasemap(b.id)}
        className={`px-3.5 py-1.5 rounded-full text-xs font-heading font-semibold transition-colors ${
          basemap === b.id ? "bg-[#2ec4b6] text-black" : "text-zinc-200 hover:bg-white/10"
        }`}
      >
        {b.label}
      </button>
    ))}
  </div>
);
